import React from "react";
import ImageSkeleton from "./ImageSkeleton";
import TextSkeleton from "./TextSkeleton";

const CardSkeleton = ({ count = 1, className = "" }) => (
  <>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className={`overflow-hidden rounded-lg bg-white shadow-sm ${className}`}>
        <ImageSkeleton className="h-44 w-full rounded-none" />
        <div className="space-y-3 p-4">
          <div className="h-3 w-1/3 animate-pulse rounded bg-stone-300" />
          <TextSkeleton lines={2} />
        </div>
      </div>
    ))}
  </>
);

export default CardSkeleton;
